import { render, staticRenderFns } from "./TRValidatedModal.vue?vue&type=template&id=57d56da1"
import script from "./tRValidatedModal.ts?vue&type=script&lang=ts&external"
export * from "./tRValidatedModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports